@if ({answerResult: answer | async}; as item) {
    @if (hasPotentialResultsToShow && loading) {
        <app-spinner class="col-md-12" [centered]="true"></app-spinner>
    }
    <div class="answer-box" [class.collapsed-answer]="loading || !hasPotentialResultsToShow || !item?.answerResult">
        <div id="ai-answer-expander" class="answer-expander" [class.fully-expanded]="expanded">
            <div class="answer-content">
                <img class="brain-icon" src="assets/img/brain-icon.svg" alt="AI Disclaimer Icon">
                <div class="answer-icon-split">
                    <h4 class="overview-header">
                        {{'LABEL_AI_OVERVIEW' | translate}}
                    </h4>
                    <p class="answer-disclaimer">
                        {{'LABEL_AI_DISCLAIMER' | translate}}
                    </p>
                    <p gpt-content class="answer-text" [innerHTML]="item?.answerResult?.answer"></p>
                </div>
            </div>
            <div class="answer-resources">
                @for (item of item?.answerResult?.products; let i = $index; track item.objectID)
                {
                    <div class="answer-resource-card" [class.highlight]="clickedObjectId === item?.objectID">
                        <app-search-card [result]="item" [searchLogID]="i"></app-search-card>
                    </div>
                }
                <!-- response vote buttons -->
                <div class="margin-top-single response-vote">
                    <p class="margin-bottom-half">{{'LABEL_AI_RESPONSE_VOTE_QUESTION' | translate}}</p>
                    <div class="display-flex gap-single">
                        <button id="ai-answer-like" [disabled]="item?.answerResult?.rating === 1" (click)="rateResponse(item?.answerResult?.searchLogId, 1)" class="button button--small button--secondary">{{'LABEL_YES' | translate}}</button>
                        <button id="ai-answer-dislike" [disabled]="item?.answerResult?.rating === -1" (click)="rateResponse(item?.answerResult?.searchLogId, -1)" class="button button--small button--secondary">{{'LABEL_NO' | translate}}</button>
                    </div>
                </div>
            </div>
        </div>

        @if (shouldBeExpandable(item?.answerResult?.answer) || item?.answerResult?.products?.length) {
            <button id="ai-answer-show-button" class="button button--text icon-plus" [attr.aria-expanded]="expanded"
                aria-controls="ai-answer-expander" (click)="toggleExpand()">
                {{(expanded ? 'LINK_SHOWLESS' : 'LABEL_SHOW_MORE') | translate}}
            </button>
        }
    </div>
}
